import React from 'react'
import * as a from '../'

type Props = {
  fieldProps: any
  touched?: any
  errors?: any
  displayText?: string
  verticalLabel?: boolean
  errorPlaceholder?: boolean
  disabled?: boolean
  compact?: boolean
  width?: string
  onKeyDown?: any
  comparisonValue?: any
  comparisonEntryMode?: any
}

export const AncientInputText: React.FC<Props> = ({
  displayText,
  fieldProps,
  touched,
  errors,
  verticalLabel,
  errorPlaceholder,
  disabled,
  compact,
  width,
  onKeyDown,
  comparisonValue,
                                                    comparisonEntryMode
}) => {
  const onKeyDownHandler = (e: any) => {
    //Check if enter is pressed, if it is, call onKeyDown function
    if (e.keyCode == 13) {
      e.preventDefault()
      onKeyDown()
    }
  }
  const ENTRY_MODE = {
    EnterValue: 0,
    NotApplicable: 1,
    CurrentValue: 2
  }

  const textbox = () => {
    return (
      <>
        <input
          type='text'
          className={
            'form-control mb-3 mb-lg-0 ' +
            (compact ? 'form-control-sm' : 'form-control-lg') +
            (errors !== undefined ? ' is-invalid' : '')
          }
          style={{width: width != undefined ? width : null}}
          placeholder={displayText}
          disabled={disabled}
          onKeyDown={onKeyDownHandler}
          {...fieldProps}
        />
        {comparisonValue && (<i>Current Value: {comparisonValue}</i>)}
        {comparisonEntryMode == ENTRY_MODE.NotApplicable && (<i>Current Value: N/A</i>)}
        {errors != undefined ? (
          <div className='fv-plugins-message-container' style={{fontSize: '12px', color: 'red'}}>
            <div className='fv-help-block'>{errors}</div>
          </div>
        ) : (
          <></>
        )}
      </>
    )
  }

  return (
    <>
      {verticalLabel == true ? (
        <a.AncientFormWrapVertical displayText={displayText}>{textbox()}</a.AncientFormWrapVertical>
      ) : (
        <a.AncientFormWrapHorizontal displayText={displayText}>
          {textbox()}
        </a.AncientFormWrapHorizontal>
      )}
    </>
  )
}
